import {
  Component, ContentChild,
  forwardRef,
  Input,
  OnInit, TemplateRef, ViewChild
} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";
import {NgSelectComponent} from "@ng-select/ng-select";

/**
 * Компонент для списка со множественным выбором, выбранные значения которого должны склеиваться в одну строку
 */

@Component({
  selector: 'app-joined-multi-select',
  template: `
    <ng-select [items]="items"
               [(ngModel)]="model"
               [ngClass]="{ 'is-invalid': isInvalid }"
               (ngModelChange)="updateValue($event)"
               class="custom-select-field"
               [multiple]="true"
               [appendTo]="'body'"
               [hideSelected]="true"
               [clearable]="false"
               [bindValue]="codeField"
               [disabled]="isReadOnly"
               [searchFn]="customSearchFn"
               clearAllText="Очистить"
               [attr.title]="tooltip"
               loadingText="Загрузка справочника"
               #ngSelect>
      <ng-template ng-label-tmp let-item="item" let-clear="clear">
        <span>
          <template [ngTemplateOutlet]="labelTemplate" [ngTemplateOutletContext]="{$implicit: item, clear: clear}"></template>
        </span>
      </ng-template>
      <ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
        <div [ngOptionHighlight]="search? search.trim(): search">
          <template [ngTemplateOutlet]="optionTemplate" [ngTemplateOutletContext]="{$implicit: item}"></template>
        </div>
      </ng-template>
    </ng-select>
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => JoinedMultiSelectComponent),
      multi: true,
    },
  ],
})
export class JoinedMultiSelectComponent implements ControlValueAccessor {
  model: any;
  @Input() isReadOnly: boolean;
  @Input() items: Array<any>[];
  @Input() separator: string = ';';
  @Input() isInvalid;
  @Input() codeField: string = 'code';
  @Input() nameField: string = 'name';

  @ContentChild('labelTemplate') labelTemplate: TemplateRef<any>;
  @ContentChild('optionTemplate') optionTemplate: TemplateRef<any>;
  @ViewChild('ngSelect') ngSelect: NgSelectComponent;

  onChange = (result: any) => {};
  onTouch = () => {
  }

  constructor() { }


  writeValue(value: string) {
    const values = value.split(this.separator);
    this.model=values;
  }

  registerOnChange(callback) {
    this.onChange = callback;
  }

  registerOnTouched(callback) {
    this.onTouch = callback;
  }

  /**
   * Меняем руками и сообщаем Forms API об обновлении
   */
  updateValue(insideValue: any) {
    this.onChange(this.model.join(this.separator));
  }

  /**
   * Свой поиск
   * обернули в функцию что бы получить контекст this
   */
  customSearchFn = (term: string, item: any) => {
    if (term && item) {
      term = term.toLocaleLowerCase();
      return item[this.codeField].toLocaleLowerCase().indexOf(term) > -1
        || item[this.nameField].toLocaleLowerCase().indexOf(term) > -1;
    }
    return true;
  }

  get tooltip(): string | undefined {
    // возвращаем название объекта по пришедшему id (model)
    return this.items?.find(
      ((item) => item?.[this.codeField] && item?.[this.codeField] === this.model)
    )?.[this.nameField];
  }
}
